module.exports = __webpack_public_path__ + "static/img/awayPenaltyGoal.eb6dd15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/awayPenaltyGoal.png
// module id = oWQy
// module chunks = 94